import ViewportRestrictor from "./ViewportRestrictor";
import createViewportRestrictor from "./createViewportRestrictor";

export const DesktopOnly = createViewportRestrictor("DesktopOnly", {
  showOnDesktop: true,
});

export const TabletOnly = createViewportRestrictor("TabletOnly", {
  showOnTablet: true,
});

export const MobileOnly = createViewportRestrictor("MobileOnly", {
  showOnMobile: true,
});

export const NoDesktop = createViewportRestrictor("NoDesktop", {
  showOnMobile: true,
  showOnTablet: true,
});

export const NoTablet = createViewportRestrictor("NoTablet", {
  showOnDesktop: true,
  showOnMobile: true,
});

export const NoMobile = createViewportRestrictor("NoMobile", {
  showOnDesktop: true,
  showOnTablet: true,
});

export default ViewportRestrictor;
